import { render, staticRenderFns } from "./DebugControllerForm.vue?vue&type=template&id=188e1e25&scoped=true&"
import script from "./DebugControllerForm.vue?vue&type=script&lang=js&"
export * from "./DebugControllerForm.vue?vue&type=script&lang=js&"
import style0 from "./DebugControllerForm.vue?vue&type=style&index=0&id=188e1e25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e1e25",
  null
  
)

export default component.exports